import PQueue from 'p-queue';

export interface WordSense {
  headword_id: number;
  pinyin: string;
  sense: string;
  simp: string;
  source: number;
  source_name: string;
  trad: string;
}

interface DictionaryResponse {
  ambiguous: boolean;
  multiple: boolean;
  senses: WordSense[];
}

export class ApiClient {
  queue = new PQueue({ concurrency: 5 });
  sentenceCache: { [sentence: string]: Promise<string> } = {};
  wordCache: { [word: string]: Promise<WordSense | undefined> } = {};

  async sentenceToPinyin(sentence: string): Promise<string> {
    if (!this.sentenceCache[sentence]) {
      const loadingPromise = this.queue.add(() => $.getJSON('/api/pinyin', { text: sentence }));
      this.sentenceCache[sentence] = loadingPromise.catch((err) => {
        this.sentenceCache[sentence] = undefined;
        throw err;
      });
    }
    return this.sentenceCache[sentence];
  }

  async wordToSense(word: string): Promise<WordSense | undefined> {
    if (!this.wordCache[word]) {
      const loadingPromise: Promise<DictionaryResponse> = this.queue.add(() => $.getJSON('/api/dictionary', { query: word }));
      this.wordCache[word] = loadingPromise.then(res => res.senses[0]).catch((err) => {
        this.wordCache[word] = undefined;
        throw err;
      });
    }
    return this.wordCache[word];
  }

  reset() {
    this.sentenceCache = {};
    this.wordCache = {};
  }
}

export default new ApiClient();
